import React from 'react';
import { Page } from '../interfaces/Page';
import { ProtectedContainerProps } from '../interfaces/PagesProps';
import getPage from './getPage';

const getPages = (
  pages: Page[],
  ProtectedContainer: React.FC<ProtectedContainerProps>,
  isAuthenticated: boolean,
  basePathPages: string,
) => {
  if (!pages.length) return null;

  return pages.map((page) => getPage({ ...page, path: `${basePathPages}/${page.path}` }, isAuthenticated, ProtectedContainer));
};

export default getPages;
